import { AlertMessage } from '@/components/shared/AlertMessage';
import { CardHeader } from '@/components/shared/CardHeader';
import { InputWithLabel } from "@/components/shared/InputWithLabel";
import { Loading } from '@/components/shared/Loading';
import { RowTableWithButtonPrograma } from '@/components/shared/RowTableWithButtonPrograma';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';

import { IDisciplinasEmentaComponentProps } from '@/@types/Graduacao/DisciplinasEmenta'


/**
 * Componente para exibir o programa das disciplinas.
 * @param isLoading Indica se os dados estão sendo carregados
 * @param ano Ano do catálogo das disciplinas
 * @param data Dados das disciplinas a serem exibidos
 * @param setAno Função para atualizar o ano do catálogo
 * @param setSigla Função para atualizar a sigla da disciplina
 * @param sigla Sigla da disciplina a ser pesquisada
 * @returns Componente de programa das disciplinas
 */

const DisciplinasEmentaComponent = ({ isLoading, ano, data, setAno, setSigla, sigla }: IDisciplinasEmentaComponentProps) => {
    return (
        <div>
            <div className='mt-[16px] w-full border-[1px] rounded-[0.25rem]'>

                <CardHeader>
                    <InputWithLabel
                        label='Ano Catálogo'
                        placeholder='Ano Catálogo'
                        onChange={({ target }) => setAno(parseInt((target.value)))}
                        type='number'
                        value={ano}
                        min={2007}
                    />
                    <InputWithLabel
                        label='Sigla'
                        placeholder='Sigla da Disciplina'
                        onChange={({ target }) => {
                            setSigla(target.value);
                        }}
                        type='text'
                        value={sigla}
                    />
                </CardHeader>

                {
                    isLoading ? (
                        <Loading color='primary' />
                    ) : (
                        data.length > 0 ? (
                            <Table className='mt-[16px] table-auto'>
                                <TableHeader>
                                    <TableRow>
                                        <TableHead>
                                            Ano Catálogo
                                            <br />
                                            Tipo
                                            <br />
                                            Oferecimento
                                        </TableHead>

                                        <TableHead>
                                            Sigla
                                            <br />
                                            Disciplinas
                                        </TableHead>

                                        <TableHead>
                                            Num Cred
                                            <br />
                                            CH
                                            <br />
                                            Período
                                        </TableHead>

                                        <TableHead>
                                            Programa
                                        </TableHead>
                                    </TableRow>
                                </TableHeader>

                                <TableBody>
                                    {data.map((disciplina, index) => {
                                        return <RowTableWithButtonPrograma key={index} data={disciplina} />
                                    })}
                                </TableBody>
                            </Table>
                        ) : <AlertMessage message='Não há dados disponíveis para o ano ou sigla selecionados. Por favor, verifique os critérios de pesquisa e tente novamente.' />
                    )
                }



            </div>
        </div>
    );
}

export { DisciplinasEmentaComponent };